import { render, staticRenderFns } from "./QuotationCafezalModal.vue?vue&type=template&id=201d72b6&scoped=true"
import script from "./QuotationCafezalModal.vue?vue&type=script&lang=js"
export * from "./QuotationCafezalModal.vue?vue&type=script&lang=js"
import style0 from "./QuotationCafezalModal.vue?vue&type=style&index=0&id=201d72b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201d72b6",
  null
  
)

export default component.exports